const BASE = import.meta.env.VITE_API_URL ?? '';

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const token = localStorage.getItem('mdai_token');
  const res = await fetch(`${BASE}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(init?.headers ?? {}),
    },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    // Expired or revoked session → drop the token and bounce to login, so a stale
    // token never lingers showing errors.
    if (res.status === 401 && token && path !== '/api/auth/login') {
      localStorage.removeItem('mdai_token');
      window.dispatchEvent(new CustomEvent('mdai-auth-expired'));
    }
    const err = new Error(`api ${path}: ${res.status}`) as Error & { status?: number; body?: unknown };
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return res.json() as Promise<T>;
}
